function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useContext, useEffect } from 'react';
import { postAnonymousProgramEligibilityCheckAction } from '@applyboard/ab-common';
import { connect } from 'react-redux';
import { NUMBER_OF_QUESTIONS } from "../../Common/Constants";
import EligibilityResultsContext from "./EligibilityResultsContext";
import MarketsContext from "../Markets/MarketsContext";
import { formatPayload } from "../../Utilities/ResultsHelper";
import { getHasAnsweredAllQuestions } from "../../../../store/Selectors";
import { useAppContext } from "../App/AppProvider";
var initialResults = {
  eligibility: ''
};
var initialSearchData = {
  must_save_residency: 't',
  nationality: '',
  country_of_residency: '',
  education_country: '',
  graduated: false,
  studied_level: '',
  grading_scheme: 0,
  grade: '',
  grade_scale: ''
};
var EligibilityResultsProvider = function EligibilityResultsProvider(_ref) {
  var application = _ref.application,
    children = _ref.children,
    hasAnsweredAllQuestions = _ref.hasAnsweredAllQuestions,
    validKeys = _ref.validKeys;
  var _useState = useState(_objectSpread({}, initialResults)),
    _useState2 = _slicedToArray(_useState, 2),
    result = _useState2[0],
    setResult = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isResultsLoading = _useState4[0],
    setIsResultsLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isResultsFailed = _useState6[0],
    setIsResultsFailed = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    alreadyAppliedMessage = _useState8[0],
    setAlreadyAppliedMessage = _useState8[1];
  var _useContext = useContext(MarketsContext),
    marketsData = _useContext.data,
    isMarketsDataLoading = _useContext.isLoading;
  var _useState9 = useState(_objectSpread({}, initialSearchData)),
    _useState10 = _slicedToArray(_useState9, 2),
    searchData = _useState10[0],
    setSearchData = _useState10[1];
  var _useAppContext = useAppContext(),
    programId = _useAppContext.programId;
  var hasFetchedMarketsData = marketsData.length > 0;

  // eslint-disable-next-line no-restricted-syntax -- TODO: re-evaluate if this is needed
  useEffect(function () {
    if (!hasAnsweredAllQuestions) {
      setResult(_objectSpread({}, initialResults));
    }
  }, [hasAnsweredAllQuestions]);
  var prepareResultsObject = function prepareResultsObject(response) {
    var _response$body;
    var _ref2 = (response === null || response === void 0 ? void 0 : (_response$body = response.body) === null || _response$body === void 0 ? void 0 : _response$body.data) || {},
      attributes = _ref2.attributes,
      type = _ref2.type,
      id = _ref2.id;
    var resultObj = {
      eligibility: attributes === null || attributes === void 0 ? void 0 : attributes.eligibility
    };
    if (type === 'application') {
      setResult(_objectSpread(_objectSpread({}, resultObj), {}, {
        applicationId: id
      }));
      var message = attributes !== null && attributes !== void 0 && attributes.paid ? 'You have already applied.' : 'You have already added this program to your applications.';
      setAlreadyAppliedMessage(message);
      return;
    }
    if (!resultObj.eligibility || resultObj.eligibility === 'unknown') {
      console.error("Missing or 'unknown' eligibility.");
      setIsResultsFailed(true);
      return;
    }
    if (attributes !== null && attributes !== void 0 && attributes.intake_available) resultObj.intake_available = attributes.intake_available;
    if (attributes !== null && attributes !== void 0 && attributes.recruitment_restricted) {
      resultObj.recruitment_restricted = attributes.recruitment_restricted;
    }
    if (attributes !== null && attributes !== void 0 && attributes.criteria) resultObj.criteria = attributes.criteria;
    if (attributes !== null && attributes !== void 0 && attributes.elp_info_hack) resultObj.elp_info_hack = attributes.elp_info_hack;
    setResult(_objectSpread({}, resultObj));
  };
  var fetchResults = function fetchResults() {
    if (!hasFetchedMarketsData) return;
    if (validKeys.length < NUMBER_OF_QUESTIONS) return;
    var data = formatPayload(application, marketsData);
    setSearchData(_objectSpread({}, data));
    setIsResultsLoading(true);
    postAnonymousProgramEligibilityCheckAction({
      program_id: programId
    }, data).then(function (response) {
      if (response) {
        prepareResultsObject(response);
      } else {
        setIsResultsFailed(true);
      }
      setIsResultsLoading(false);
    }, function (err) {
      console.error(err);
      setIsResultsFailed(true);
    });
  };
  var eligibilityResults = {
    result: result,
    searchData: searchData,
    isResultsLoading: isResultsLoading,
    isMarketsDataLoading: isMarketsDataLoading,
    isResultsFailed: isResultsFailed,
    alreadyAppliedMessage: alreadyAppliedMessage,
    hasFetchedMarketsData: hasFetchedMarketsData
  };
  var value = {
    eligibilityResults: eligibilityResults,
    fetchResults: fetchResults
  };
  return /*#__PURE__*/React.createElement(EligibilityResultsContext.Provider, {
    value: value
  }, children);
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    hasAnsweredAllQuestions: getHasAnsweredAllQuestions(state)
  };
};
var connector = connect(mapStateToProps, null);
export default connector(EligibilityResultsProvider);